import { render, staticRenderFns } from "./ElectionCategories.vue?vue&type=template&id=065eedc7&scoped=true"
import script from "./ElectionCategories.vue?vue&type=script&lang=js"
export * from "./ElectionCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065eedc7",
  null
  
)

export default component.exports